const HALO_KEY_RISK_AREA_TREND_DESCRIPTION =
  'This chart shows the rolling 30-day trend for the aggregated scores for your Portfolio of Suppliers across the five key risk areas';

export default HALO_KEY_RISK_AREA_TREND_DESCRIPTION;
